const setSessionStorageItem = (name: string, value: string, dispatchStorageEvent = false) => {
    if (!name || typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }

    sessionStorage.setItem(name, value);
    if (dispatchStorageEvent) {
        const event = new CustomEvent<{ name: string; value: string }>('sessionStorageChange', {
            detail: { name, value },
        });
        window.dispatchEvent(event);
    }
};

const getSessionStorageItem = (name: string): string | null => {
    if (!name || typeof window === 'undefined' || !window.sessionStorage) {
        return null;
    }

    return sessionStorage.getItem(name);
};

const removeSessionStorageItem = (name: string) => {
    if (!name || typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }

    sessionStorage.removeItem(name);
};

export default {
    getSessionStorageItem,
    removeSessionStorageItem,
    setSessionStorageItem,
};
